export default class NullLogger {
    debug() { }
    error() { }
    info() { }
    warning() { }
    withEnricher() {
        return new NullLogger();
    }
}
//# sourceMappingURL=nullLogger.js.map